/**
 * ss-brand-story.js
 * Phase 04 — Brand Story parallax + image reveal
 * Minimal, GPU-accelerated, respects reduced motion.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initParallax() {
    if (reduceMotion) return;

    var targets = document.querySelectorAll('[data-brand-parallax]');
    if (!targets.length) return;

    var ticking = false;

    function update() {
      targets.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var viewH = window.innerHeight;
        if (rect.bottom < 0 || rect.top > viewH) return;
        var progress = (viewH - rect.top) / (viewH + rect.height);
        var shift = (progress - 0.5) * 24;
        el.style.transform = 'translate3d(0, ' + shift.toFixed(2) + 'px, 0)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function initImageReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var visuals = document.querySelectorAll('[data-brand-visual]');
    if (!visuals.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-image-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    visuals.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    initParallax();
    initImageReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
